import React from 'react';
import { Col } from 'react-bootstrap';
import Heading from './heading/heading';
import './featurebox.scss';
class FeatureBox extends React.Component {
  render() {
    return(
      <Col md={4} className="featurebox">
          <Heading as="h4" >{this.props.heading}</Heading>
            <div className="featurebox-body mt-4">{this.props.body}</div>
      </Col>
    )
  }
}

export default FeatureBox;